import {
  Component,
  OnInit,
  HostBinding,
  ViewEncapsulation,
  AfterViewChecked,
  Inject,
  forwardRef,
  ViewChild,
  // ElementRef
} from '@angular/core';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { ConfigService } from '@argalis-apps/angular-global';
import { Location } from '@angular/common';
import { SessionService } from '../../../services/session/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MUser } from '@argalis-apps/models';
import { AuthService } from '../../../../auth/services/auth/auth.service';

@Component({
  selector: 'ags-session-view',
  templateUrl: './session-view.component.html',
  styleUrls: ['./session-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SessionViewComponent implements OnInit, AfterViewChecked {
  @HostBinding('class') themeFlag: string;
  @ViewChild('menu') menu: any;
  private typeUserFormateur: number = MUser.ETypeUser.FORMATEUR;
  public idSession: number;
  public urlEmargement: string;
  public selectedMenu: string;
  public headerData: any;
  public userConnected: MUser.CUser = null;
  public prerequisSessionData: boolean;
  public loadMenu = true;
  public moduleGdeActiv = false;
  public listConsignes: { provenance: string; consigne: string }[] = [];
  public menuData: any[] = [
    {
      text: 'SYNTHÈSE',
      value: 'synthese',
    },
    {
      text: 'PLANNING',
      value: 'planning',
    },
    {
      text: 'CONSIGNE(S)',
      value: 'consigne',
    },
    {
      text: 'APPRENANT(S)',
      value: 'apprenant',
    },
    {
      text: 'PRÉSENCE',
      value: 'presence',
    },
    {
      text: 'HABILITATION',
      value: 'habilitation',
    },
    {
      text: 'ÉVALUATION',
      value: 'evaluation',
    },
    {
      text: 'COMPTE RENDU',
      value: 'rapport',
    },
    {
      text: 'DOCUMENT(S)',
      value: 'document',
      cssClass: `last-border`,
    },
  ];

  constructor(
    @Inject(forwardRef(() => AuthService)) private authService: AuthService,
    private accountConfigService: AccountConfigService,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionService: SessionService,
    private location: Location,
  ) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      this.userConnected = user;
    });
    this.route.params.subscribe((params) => {
      if (params['idSession']) {
        this.idSession = params['idSession'];
        this.getHeaderInfo(this.idSession);
        this.getHabbilationInfo(this.idSession);
      } else {
        this.router.navigate(['/account/sessions']);
      }
    });
    this.listConsignes = this.getSessionConsigneInfo(this.idSession);
  }

  ngOnInit() {
    this.sessionService.getSessionPrerequis(this.idSession).subscribe((prerequisSessionData: any) => {
      if (
        this.userConnected.type === this.typeUserFormateur &&
        (prerequisSessionData || []).length &&
        prerequisSessionData[0].id
      ) {
        this.loadMenu = true;
        const el = {
          text: 'PRÉREQUIS',
          value: 'prerequis',
        };
        this.menuData.splice(5, 0, el);
      }
    });

    this.sessionService
      .getSessionIntervenant(
        Number(this.userConnected.userInfo.id),
        Number(this.idSession),
        this.userConnected.userInfo.b_ost,
      )
      .subscribe((intervenant) => {
        if (intervenant[0].token_access) {
          this.urlEmargement = `${this.configService.getSignatureBaseUrl()}/${intervenant[0].token_access}`;
          this.moduleGdeActiv = intervenant[0].moduleGdeActif;
        }
      });

    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.selectedMenu = this.menuData[0].value;
  }

  copyToClipboard() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.urlEmargement;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  getHeaderInfo(idSession) {
    // TODO CHECK :
    // if session existe
    // if intervenant framed this session
    // DO redirection if not
    this.sessionService.getSessionHeader(idSession).subscribe((headerData: any) => {
      this.headerData = headerData[0];
    });
  }

  getHabbilationInfo(idSession) {
    this.sessionService.getHabilationBySession(idSession).subscribe((res) => {
      if (
        !res[0] ||
        !res[0].habilitation ||
        ((res[0].habilitation || {}).type !== 'CACES' &&
          (res[0].habilitation || {}).type !== 'ELECTRIQUE' &&
          (res[0].habilitation || {}).type !== 'AUTORISATION_CONDUITE')
      ) {
        this.menuData.splice(
          this.menuData.findIndex((e) => e.value === 'habilitation'),
          1,
        );
      }
    });
  }

  selectMenu(event) {
    this.changeColorOfmenu(event.index);
    this.selectedMenu = event.item.value;
  }

  changeColorOfmenu(index) {
    const list: any[] = (document.getElementById('kendo-menu').getElementsByTagName('li') || []) as any[];
    for (const elm of list) {
      elm.classList.remove('primary-background', 'colored-text');
      if (elm === list[index]) {
        elm.classList.add('primary-background', 'colored-text');
      }
    }
  }

  ngAfterViewChecked(): void {
    this.loadMenu = false;
    const menuToColor = this.menu.items.findIndex((elm) => elm.value === this.selectedMenu);
    if (menuToColor) {
      this.changeColorOfmenu(menuToColor); //eslint-disable-line
    }
  }

  goBack() {
    this.router.navigate(['/account/sessions']);
  }

  getSessionConsigneInfo(idSession: number) {
    // on crée le tableau qui contiendra les consignes
    const listMenu = [];
    const consignesSet = new Set(); // Pour garder une trace des consignes déjà ajoutées

    // L'ordre demandé est
    // 1 consigne de la session (session / intervenant)
    // 2 consigne des client commanditaire
    // 3 consigne des clients financeurs
    // 4 consigne des clients bénéficiaire
    // 5 consigne des sites clients de la session (s’il y a des sites clients avec des consignes associées)

    // on récupère les consignes de la session et des sites clients de la session :
    this.sessionService.getSessionConsigne(idSession).subscribe((res) => {
      // On affiche la consigne de la session en premier,
      // si elle n'est pas nulle et qu'elle ne contient pas que des espaces
      const consigneSession = res.sessionConsigne[0].session_consigne;
      if (consigneSession && consigneSession.replace(/\s/g, '').length && !consignesSet.has(consigneSession)) {
        listMenu.push({ provenance: 'Intervenant', consigne: consigneSession });
        consignesSet.add(consigneSession);
      }

      // on récupère les consignes des clients
      const clientConsignes = res.clientConsignes;

      const commanditaires = clientConsignes.filter((client) => client.typec.includes('Commanditaire'));
      const financeurs = clientConsignes.filter(
        (client) => !client.typec.includes('Commanditaire') && client.typec.includes('Financeur'),
      );
      const beneficiaire = clientConsignes.filter(
        (client) => !client.typec.includes('Commanditaire') && !client.typec.includes('Financeur'),
      );

      commanditaires.forEach((client) => {
        if (client.consigne && !consignesSet.has(client.consigne)) {
          listMenu.push({ provenance: `${client.nom} : Client ${client.typec}`, consigne: client.consigne });
          consignesSet.add(client.consigne);
        }
      });

      financeurs.forEach((client) => {
        if (client.consigne && !consignesSet.has(client.consigne)) {
          listMenu.push({ provenance: `${client.nom} : Client ${client.typec}`, consigne: client.consigne });
          consignesSet.add(client.consigne);
        }
      });

      beneficiaire.forEach((client) => {
        if (client.consigne && !consignesSet.has(client.consigne)) {
          listMenu.push({ provenance: `${client.nom} : Client ${client.typec}`, consigne: client.consigne });
          consignesSet.add(client.consigne);
        }
      });

      // les consignes des sites doivent apparaître en dernier
      res.sessionConsigne.forEach((consigne) => {
        if (consigne.site_consigne && !consignesSet.has(consigne.site_consigne)) {
          listMenu.push({ provenance: 'Site', consigne: consigne.site_consigne });
          consignesSet.add(consigne.site_consigne);
        }
      });

      // si aucune consigne n'est présente, on supprime la section
      if (!listMenu.length) {
        this.menuData.splice(
          this.menuData.findIndex((e) => e.value === 'consigne'),
          1,
        );
      }
    });

    return listMenu;
  }
}
